import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import invariant from 'invariant';

interface IShortcodeSettings {
	cat?: string;
	filters?: boolean;
	expired?: boolean;
	view?: string;
	venue?: string;
	tag?: string;

	//individual filters
	searchFilter?: boolean;
	locationFilter?: boolean;
	venueFilter?: boolean;
	categoryFilter?: boolean;
	tagFilter?: boolean;
}
interface IShortcodeSettingsContext {
	settings: IShortcodeSettings;
}

const ShortcodeSettingsContext = createContext<IShortcodeSettingsContext | undefined>(undefined);

export const ShortcodeSettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [settings, setSettings] = useState<IShortcodeSettings>({});

	useEffect(() => {
		const div = document.getElementById('calendar-plus');
		const calendarProps = div ? JSON.parse(div.getAttribute('data-props')) : {};

		setSettings(calendarProps);
	}, []);

	const contextValue = useMemo(() => ({ settings: { ...settings } }), [settings]);

	return <ShortcodeSettingsContext.Provider value={contextValue}>{children}</ShortcodeSettingsContext.Provider>;
};

export const useShortcodeSettings = (): IShortcodeSettingsContext => {
	const context = useContext(ShortcodeSettingsContext);

	invariant(context, 'useShortcodeSettings must be used within a ShortcodeSettingsProvider');

	return context;
};
